export default {"src":"/_next/static/media/healthyfoods.8fdee5b4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};